<a
  [routerLink]="'cart'"
  routerLinkActive="bg-indigo-700 text-neutral-50 dark:bg-indigo-500 dark:text-white"
  [class]="
    'group flex ui-row-hover transition-colors ' +
    (collapsed()
      ? 'flex-col items-center gap-0.5 px-0.5 py-1.5 text-center rounded-lg'
      : 'items-center gap-3 px-3 py-2 rounded-full')
  "
  (click)="goToCart()"
>
  <span class="w-6 h-6 grid place-items-center">
    <span
      class="inline-flex items-center justify-center min-w-5 h-5 text-xs px-1 rounded-full text-white font-black"
      [class.bg-red-500]="isNotEmpty()"
      [class.bg-neutral-800]="!isNotEmpty()"
    >
      {{ count() }}
    </span>
  </span>
  @if (collapsed()) {
  <span class="w-full text-[10px] leading-tight truncate">Panier</span>
  } @else {
  <span class="truncate text-sm">Panier</span>
  }
</a>
